import React from 'react';
import { Link } from 'react-router-dom';

export default props => (
	<li> 
		<Link to={props.path} onClick={() => {}}>
			<i className={`fa ${props.icon}`} /> 
			<span>{props.label}</span>
		</Link>
	</li>
);



// WEBPACK FOOTER //
// ./src/lib_react_adminlte/template/sidebar/MenuItem.jsx